import { StorefrontConfig } from "src/storefront/types/storefront";
import { NavigationState } from "src/storefront/types/navigation";
import { AlertContext } from "src/components/alert";
import { Cart, CartItem } from "src/storefront/types/cart";
import searchInsights from "search-insights";
import { CartItemEvent, CartItemEventSerializer } from "src/analytics/cart_item_event_serializer";
import { CartWithAlertMessage } from "src/storefront/decoders";
import { Catalog } from "src/storefront/types/catalog";

const buildAddToCart = (
  cart: CartWithAlertMessage | null,
  catalog: Catalog | undefined,
  config: StorefrontConfig,
  navigationState: NavigationState,
  setCartItems: (cartItems: CartItem[]) => Promise<CartWithAlertMessage>,
  showAlert: AlertContext,
  pushDataEvent: (cartItemEvent: CartItemEvent) => void,
) => {
  return async (newCartItem: CartItem, index?: number): Promise<Cart> => {
    let newCart;
    if (!cart) {
      newCart = [newCartItem];
    } else if (index !== undefined) {
      newCart = [...cart.cartItems];
      newCart.splice(index, 0, newCartItem);
    } else {
      const matchingItem = [...cart.cartItems].reverse().find(ci => ci.isStackableWith(newCartItem))

      if (matchingItem) {
        const updatedMatchingItem = matchingItem.copyWith({ quantity: newCartItem.quantity + matchingItem.quantity })

        newCart = cart.cartItems.map(ci => ci.idTarget == updatedMatchingItem.idTarget ? updatedMatchingItem : ci);
      } else {
        newCart = cart.cartItems.concat([newCartItem]);
      }
    }

    if (navigationState.queryId) {
      searchInsights("addedToCartObjectIDsAfterSearch", {
        index: config.searchIndexName,
        eventName: "Product added to cart after search",
        queryID: navigationState.queryId,
        objectIDs: [`${config.storefrontId};${newCartItem.key}`],
      })
    } else {
      searchInsights("addedToCartObjectIDs", {
        index: config.searchIndexName,
        eventName: "Product added to cart",
        objectIDs: [`${config.storefrontId};${newCartItem.key}`],
      })
    }

    const mutationResult = await setCartItems(newCart);

    if (mutationResult.alertMessage) {
      showAlert(mutationResult.alertMessage);
    }

    if (catalog) {
      const serializer = new CartItemEventSerializer(catalog, config.defaultItemsEventAttributes)

      const addToCartEvent = serializer.addToCartEvent(newCartItem);

      pushDataEvent(addToCartEvent);
    }

    return mutationResult
  }
}

export default buildAddToCart;